import { useQuery } from '@tanstack/react-query';

import type { Contact } from '../../../domain/contact';
import type { Crm } from '../../../domain/crm';
import { crmApi } from '../api';

export const usePreviewContactsQuery = ({
  crm,
  contacts,
  enabled,
}: {
  crm: Crm;
  contacts: Contact[];
  enabled: boolean;
}) => {
  return useQuery({
    queryKey: ['contacts-export-preview', crm, ...contacts.map((contact) => contact.id)],
    queryFn: ({ signal }) => crmApi.exportContactsPreview({ contacts, crm }, signal),
    enabled,
  });
};
